import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./languages/en.json";
import al from "./languages/al.json";
import sr from "./languages/sr.json";
import mk from "./languages/mk.json";
import me from "./languages/me.json";

const resources = {
  en: { translation: en },
  sq: { translation: al },
  sr: { translation: sr },
  mk: { translation: mk },
  me: { translation: me },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
